import {MUTATION_NAME} from '@/static/global-variables';

const messageStore = {
    namespaced: true,
    state: {
        veevaMessage: {}
    },
    getters: {
        veevaMessage: state => state.veevaMessage,
    },
    mutations: {
        [MUTATION_NAME.SET_VEEVA_MESSAGE]: (state, veevaMessage) => {
            state.veevaMessage = veevaMessage || {};
        }
    }
};

export default messageStore;
